export default Object.freeze({
    MONEY: 0,
    CREDITS: 1,
});
